@switch (context ? context.type : '') {
    @default {
        <fui-edit-numeric-input [control]="control" [disabled]="disabled" #input [label]="label" [(ngModel)]="value"
                                (focussed$)="onFocussed($event)" [notation]="notation" [decimals]="decimals"
                                [showClear]="showClear"
                                [placeholder]="placeholder">
        </fui-edit-numeric-input>
    }
    @case (contextType.FILTER) {
        <fui-filter-numeric-input [disabled]="disabled" #input [label]="label" [(ngModel)]="value" [decimals]="decimals"
                                  [placeholder]="placeholder" (focussed$)="onFocussed($event)">
        </fui-filter-numeric-input>
    }
    @case (contextType.INLINE) {
        <fui-inline-numeric-input [control]="control" [disabled]="disabled" #input [(ngModel)]="value"
                                  (focussed$)="onFocussed($event)" [notation]="notation"
                                  [decimals]="decimals" [placeholder]="placeholder">
        </fui-inline-numeric-input>
    }
    @case (contextType.HEADER) {
        <fui-header-numeric-input [control]="control" [disabled]="disabled" #input [(ngModel)]="value"
                                  (focussed$)="onFocussed($event)" [notation]="notation"
                                  [decimals]="decimals" [placeholder]="placeholder">
        </fui-header-numeric-input>
    }
    @case (contextType.PILL) {
        <fui-numeric-pill [control]="control" [disabled]="disabled" [label]="label" #input [(ngModel)]="value"
                          [removable]="removable" (removed$)="remove()" [placeholder]="placeholder"
                          (focussed$)="onFocussed($event)" [decimals]="decimals">
        </fui-numeric-pill>
    }
}
